import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-movie-2-line text-2xl" style={{ color: isScrolled ? "oklch(var(--primary-500))" : "#ffffff" }}></i>
            </div>
            <span
              className="text-xl font-bold tracking-wide"
              style={{
                fontFamily: "var(--font-heading)",
                color: isScrolled ? "oklch(var(--foreground-950))" : "#ffffff",
              }}
            >
              光棍影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === "/"
                  ? isScrolled
                    ? "text-primary-500"
                    : "text-white font-bold"
                  : isScrolled
                  ? "text-foreground-700 hover:text-primary-500"
                  : "text-white/80 hover:text-white"
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? isScrolled
                      ? "text-primary-500"
                      : "text-white font-bold"
                    : isScrolled
                    ? "text-foreground-700 hover:text-primary-500"
                    : "text-white/80 hover:text-white"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === "/about"
                  ? isScrolled
                    ? "text-primary-500"
                    : "text-white font-bold"
                  : isScrolled
                  ? "text-foreground-700 hover:text-primary-500"
                  : "text-white/80 hover:text-white"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl ${isScrolled ? "text-foreground-950" : "text-white"}`}
              style={{ color: isScrolled ? "oklch(var(--foreground-950))" : "#ffffff" }}
            >
              {isMenuOpen ? "ri-close-line" : "ri-menu-line"}
            </i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 py-4 px-2">
            <div className="flex flex-col gap-3">
              <Link
                to="/"
                className="text-sm font-medium text-foreground-950 px-3 py-2 rounded-md hover:bg-background-100"
                onClick={() => setIsMenuOpen(false)}
              >
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm font-medium text-foreground-700 px-3 py-2 rounded-md hover:bg-background-100"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="text-sm font-medium text-foreground-700 px-3 py-2 rounded-md hover:bg-background-100"
                onClick={() => setIsMenuOpen(false)}
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}